module.exports = __webpack_public_path__ + "img/jujutsu_logo.b0aa0c82.png";